import "react";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/components/NoContentPlaceholder.tsx
var NoContentPlaceholder = ({ children, className, icon }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: classnames("flex flex-col items-center text-center text-color-neutral-faded", className),
		children: [icon, typeof children === "string" ? /* @__PURE__ */ jsx("div", {
			className: "font-lg mt-sm max-w-[450px] font-medium",
			children
		}) : children]
	});
};
//#endregion
export { NoContentPlaceholder };

//# sourceMappingURL=NoContentPlaceholder.js.map